<template>
    <div class="cmd-box">
        <el-row>
            <el-col span="8">
                <el-form ref="form" :model="form" label-width="80px" label-position="top">
                    <el-form-item label="设备SN">
                        <el-input v-model="form.sn" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="出货货道">
                        <el-table
                                :data="form.items"
                                border
                                style="width: 100%">
                            <el-table-column
                                    prop="equNo"
                                    label="机柜号"
                            >
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.equNo" placeholder="机柜号"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="equType"
                                    label="机柜类型"
                            >
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.equType" placeholder="机柜类型"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="seqNo"
                                    label="货道号"
                            >
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.seqNo" placeholder="货道号"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    label="操作"
                            >
                                <template slot-scope="scope">
                                    <el-button size="mini" @click="form.items.splice(form.items.indexOf(scope.row),1)">
                                        删除
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div>
                            <el-button size="mini" @click="handleAddItems">新增</el-button>
                        </div>
                    </el-form-item>

                    <el-form-item>
                        <el-button type="primary" size="mini" @click="handleSubmit('form')">确定</el-button>
                        <el-button size="mini" @click="handleReset('form')">重置</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
            <el-col span="16">
                <div style="padding: 24px">
                    <div v-for="(log,i) in logs" :key="i" style="font-size: 12px;margin-bottom: 12px;word-break: break-word">
                        {{log}}
                    </div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    export default {
        name: "ShipmentCmdBox",
        props: {
            sn: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                form: {
                    sn: '',
                    items: [
                        {
                            equNo: '1',
                            equType: '1',
                            seqNo: '1'
                        }
                    ]
                },
                logs: [],
                afterTime: '',
                timer: ''
            }
        },
        watch: {
            sn: {
                immediate: true,
                handler() {
                    this.form.sn = this.sn;
                }
            }
        },
        methods: {
            handleAddItems() {
                this.form.items.push({
                    equNo: '1',
                    equType: '1',
                    seqNo: '1'
                });
            },
            async handleSubmit() {
                this.logs = [];
                clearTimeout(this.timer);
                this.logs.push("正在准备发送指令...");
                await this.loadLog();
                this.timerLoadLog(1000);
                let resp = await this.$http.post(this.$api.$base.root + '/gw/server/shipment', Object.assign({reqId: "AT" + new Date().getTime()}, this.form), {headers: {sn: this.sn}});
                if (resp.data.status === 200) {
                    this.logs.push("指令发送完成...");
                } else {
                    this.logs.push("指令发送失败，" + resp.data.desc);
                }
            },
            async loadLog() {
                let resp = await this.$http.post(this.$api.spDevLog.list, this.$qs.stringify({
                    sn: this.sn,
                    asc: true,
                    afterTimeStp: this.afterTime
                }));
                if (!this.afterTime) {
                    this.afterTime = resp.data.time;
                } else {
                    if (resp.data.data.spDevLogs && resp.data.data.spDevLogs.length) {
                        let spDevLogs = resp.data.data.spDevLogs;
                        this.afterTime = spDevLogs[spDevLogs.length - 1].createTime;
                        spDevLogs.forEach((e) => {
                            this.logs.push(e.content);
                        })
                    }
                }
                return;
            },
            async timerLoadLog(time) {
                if (!time) {
                    time = 1000;
                }
                return new Promise(async (res) => {
                    await this.loadLog();
                    this.timer = setTimeout(async () => {
                        res();
                        await this.timerLoadLog(time);
                    }, time);
                })
            },
            handleReset() {
                this.form = {
                    sn: this.sn,
                    items: [
                        {
                            equNo: '1',
                            equType: '1',
                            seqNo: '1'
                        }
                    ]
                };
            }
        }
    }
</script>

<style scoped>
    .cmd-box {
    }
</style>